/* Bag gap filler: "Upgrade to reflective" (snippets/runit-cart-reflective-upgrade.liquid).
   One delegated listener, loaded site-wide, so it works on rows a drawer re-render inserts. */
window.rlReflUp || document.addEventListener('click', window.rlReflUp = function (e) {
  var b = e.target.closest && e.target.closest('[data-rl-refl-up]');
  if (!b) return;
  e.preventDefault();
  if (b.getAttribute('aria-busy') === 'true') return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = document.querySelector('cart-drawer'), added = false, props = {};
  // Liquid's `properties | json` is a list of [name, value] pairs.
  try { props = JSON.parse(b.dataset.props || '{}') || {}; if (Array.isArray(props)) props = Object.fromEntries(props); } catch (err) {}
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'Could not upgrade it. Please try again.'); return j; }); });
  }
  b.setAttribute('aria-busy', 'true');
  post('cart/add.js', { items: [{ id: +b.dataset.variant, quantity: +b.dataset.qty, properties: props }] })
    .then(function () {
      added = true;
      // Line keys can change when the cart changes, so find the old line again by variant + properties.
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      var want = JSON.stringify(props), old = (cart.items || []).filter(function (i) {
        return String(i.variant_id) === b.dataset.from && JSON.stringify(i.properties || {}) === want;
      })[0];
      if (!old) throw new Error('Could not upgrade it. Please try again.');
      var body = { id: old.key, quantity: 0 };
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
      return post('cart/change.js', body);
    })
    .then(function (j) { if (drawer && drawer.renderContents && j.sections) drawer.renderContents(j); else location.reload(); })
    .catch(function (err) {
      if (added) { location.reload(); return; } // both lines are in the bag: show the real state
      b.removeAttribute('aria-busy');
      var m = b.closest('[data-rl-refl-up-row]').querySelector('.rl-refl-up__error');
      m.textContent = err.message; m.hidden = false;
    });
});
